module.exports = __webpack_public_path__ + "img/symbol_9.2093d2a1.png";